<template>
    <benefit-dialog :visible="visible" :type="4">
    <h2 class="benefit-title" slot="title">活动说明</h2>
    <div slot="body" class="benefit-intro-box">
      <div>
        一、在活动时间内，已领取迅雷会员或现金券的用户请在{{validDays}}天内登录手机迅雷进行激活，逾期视为自动放弃；
      </div>
      <div>
        二、请使用领取奖励时填写的手机号码登录手机迅雷，从未安装过手机迅雷的用户可得{{vipDays}}天迅雷会员，老用户可得{{voucherAmount}}元会员代金券；
      </div>
      <div>
        三、每个手机号码仅可激活一次迅雷会员，重复激活无效；
      </div>
      <div>
        四、参与活动的手机号码须为本人持有，若系统判定存在机器人行为，奖励将会被取消；
      </div>
      <div>五、请在安卓版手机迅雷中进行领取，iOS用户暂时无法参与活动。</div>
    </div>
    <benefit-button slot="footer" @click.native="handleClose">我知道了</benefit-button>
  </benefit-dialog>
</template>

<script>
import BenefitButton from '@/components/benefit/button.vue'
import BenefitDialog from '@/components/benefit/dialog.vue'
import eventHub from './eventHub'
export default {
  components: {
    BenefitButton,
    BenefitDialog
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    validDays: {
      type: [String, Number],
      required: true
    },
    vipDays: {
      type: [String, Number],
      required: true
    },
    voucherAmount: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    handleClose() {
      eventHub.$emit('update:visible', 4, false)
    }
  }
}
</script>

<style lang="scss">
.benefit-intro-box {
  margin: 20px; /*no*/
  font-size: 14px; /*no*/
  height: 193px; /*no*/
  overflow: scroll;
  color: #26292d;
  line-height: 20px; /*no*/
  overflow: -moz-scrollbars-none;
}
.benefit-intro-box::-webkit-scrollbar {
  width: 0 !important;
}
</style>
